import { ReactNode } from 'react';

import cn from '@/utils/cn';

interface CheckoutSummarySectionProps {
  icon: ReactNode;
  title: string;
  children: ReactNode;
  className?: string;
}

const CheckoutSummarySection = ({
  icon,
  title,
  children,
  className,
}: CheckoutSummarySectionProps) => {
  return (
    <div
      className={cn(
        'rounded-md bg-gray-200 p-3.5 md:p-6',
        'flex w-full flex-col gap-3',
        className
      )}
    >
      <div className="flex w-full items-center gap-2">
        {icon}
        <p className="h5 text-dark-gray-500">{title}</p>
      </div>
      {children}
    </div>
  );
};

export default CheckoutSummarySection;
